import script from "./MenuItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuItems.vue?vue&type=script&lang=ts&setup=true"

import "./MenuItems.vue?vue&type=style&index=0&id=3e9d45ea&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e9d45ea"]])

export default __exports__